import * as PIXI from 'pixi.js';
import Appearance from '.';
import AssetManager from '../../../Base/AssetManager';
import { Shape } from '..';
import Global from '../../../Global';
import LibraryManager from '../../../Base/Library/LibraryManager';
import Angle from '../../../Base/Math/Angle';

import { newStateObject } from '../../../../GameKit/shared';

export default class Image extends Appearance {
    constructor(gsoParent) {
        super(gsoParent);

        this.texture = newStateObject.texture;

        this.pixiContainer = null;
        this.circleMaskGraphics = null;
        this.sprites = [];

        this.hue = newStateObject.hue;
    }

    createCircleMask() {
        this.circleMaskGraphics = new PIXI.Graphics();
        this.circleMaskGraphics.beginFill(0x000000);
        this.circleMaskGraphics.drawCircle(0, 0, (Global.NATIVE_BLOCK_SIZE * this.state.blok.size.x) / 2);
        this.circleMaskGraphics.endFill();

        this.pixiContainer.mask = this.circleMaskGraphics;
        this.pixiContainer.addChild(this.circleMaskGraphics);
    }

    onCreateVisuals() {
        const game = this.getGame();
        this.pixiContainer = new PIXI.Container();

        let ySize = this.state.blok.size.y;
        if (this.state.blok.shape === Shape.circle) ySize = this.state.blok.size.x;

        if (this.texture === 'invisible' && this._inPlayMode) {
            const sprite = null;
        } else {
            let sprite = null;
            if (game.isCanvas()) {
                sprite = new PIXI.Sprite(
                    LibraryManager.textures
                        .get(this.texture)
                        .getAsset()
                        .getHue(this.hue),
                    64,
                    64
                );
            } else {
                sprite = new PIXI.heaven.Sprite(LibraryManager.textures.get(this.texture).get());
                sprite.color.hue = Angle.toRadians(this.hue);
            }
            sprite.width = Global.NATIVE_BLOCK_SIZE * this.state.blok.size.x;
            sprite.height = Global.NATIVE_BLOCK_SIZE * ySize;
            sprite.anchor.set(0.5);
            this.sprites.push(sprite);
            this.pixiContainer.addChild(sprite);
        }

        if (this.state.blok.shape === Shape.circle) {
            this.createCircleMask();
        }

        this.state.getParentPixiContainer().addChild(this.pixiContainer);
    }

    onCreateBody() {
        this.requestNewVisuals();
    }

    onDestroyBody() {
        this.requestNewVisuals();
    }

    onDestroyVisuals() {
        if (this.circleMaskGraphics) {
            this.circleMaskGraphics.destroy();
            this.circleMaskGraphics = null;
        }
        for (let i = 0; i < this.sprites.length; i++) {
            this.sprites[i].destroy();
        }
        this.pixiContainer.destroy();
        this.pixiContainer = null;
        this.sprites = [];
    }
}

Image.serializeableFields = {
    texture: String,
    hue: Number
};
